<mat-toolbar mat-dialog-title>{{ data.title }}</mat-toolbar>
<mat-dialog-content style="padding:2em 1em">{{ data.message }}</mat-dialog-content>
<dialog-form-actions>
  <button [mat-dialog-close]="true" color="primary" mat-raised-button>{{ data.button }}</button>
  <button [mat-dialog-close]="false" mat-raised-button>cancel</button>
</dialog-form-actions>
